"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userServiceStatsSchema = void 0;
const zod_1 = require("zod");
exports.userServiceStatsSchema = zod_1.z.object({
  /** Количество запланированных митингов */
  meetings_upcoming_count: zod_1.z.number().optional(),
  /** Количество проведённых митингов */
  meetings_done_count: zod_1.z.number().optional()
});
